<template>
  <div>
    <ProfileCircle></ProfileCircle>
  </div>
</template>

<script>
import ProfileCircle from '../../commons/profile/circle/Circle'

export default {
  components: {
    ProfileCircle
  },
  data () {
    return {
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/DoctorCircles.vue